export default __webpack_public_path__ + "static/20-ee9644f59805f472079d9a08bfd57a65.jpg";